import { render, staticRenderFns } from "./CustomerVitalListPage.vue?vue&type=template&id=932aeff8&"
import script from "./CustomerVitalListPage.vue?vue&type=script&lang=js&"
export * from "./CustomerVitalListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports